import { render, staticRenderFns } from "./threshold.vue?vue&type=template&id=1b560170&scoped=true&"
import script from "./threshold.ts?vue&type=script&lang=ts&"
export * from "./threshold.ts?vue&type=script&lang=ts&"
import style0 from "./threshold.scss?vue&type=style&index=0&id=1b560170&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b560170",
  null
  
)

export default component.exports